import { customerTabHref } from '@/lib/customerTabs'
import { VaultFolderKey } from '@/models/vault'
import { ComplianceFileView } from '../Vault/ComplianceFileView'
import { ExpiryTimeline } from '../Vault/ExpiryTimeline'
import { VaultProvider } from '../Vault/VaultContext'
import { VaultFolders } from '../Vault/VaultFolders'
import { VaultHeroBlock } from '../Vault/VaultHeroBlock'

const TAB = 'vault'

function VaultView({ path, href }: { path: string[]; href: (path: string) => string }) {
  const [folder, second, third] = path
  const back = { to: href(''), label: 'Vault' }
  if (!folder) return <VaultFolders />
  if (folder === 'timeline') return <ExpiryTimeline />
  if (folder === VaultFolderKey.CARRIER) return <ComplianceFileView kind="carrier" back={back} />
  if (folder === VaultFolderKey.DRIVERS) {
    if (!second) return <VaultFolders />
    return <ComplianceFileView kind="drivers" entityId={second} back={{ to: href(''), label: 'Vault' }} />
  }
  if (folder === VaultFolderKey.EQUIPMENT) {
    if (!second || !third) return <VaultFolders />
    const kind = second === 'trailers' ? 'trailers' : 'trucks'
    return <ComplianceFileView kind={kind} entityId={third} back={{ to: href(''), label: 'Vault' }} />
  }
  return <VaultFolders />
}

/** A customer's vault as staff see it. `path` is its place inside the tab: `['equipment', 'trucks', id]`. */
export function VaultTab({ orgId, path }: { orgId: string; path: string[] }) {
  const href = (rest: string) => customerTabHref(orgId, TAB, rest)
  return (
    <VaultProvider orgId={orgId} href={href} staff>
      <div className="flex flex-col gap-2">
        <VaultHeroBlock />
        <VaultView path={path} href={href} />
      </div>
    </VaultProvider>
  )
}
